import { Typography } from '@common/components'
import { styled } from '@common/utils/styles'

export const TypoBreakoutTime = styled(Typography)(() => ({
  '@keyframes fadeSlideIn': {
    from: {
      opacity: 0,
      width: '0px',
      marginLeft: 0,
    },
    to: {
      opacity: 1,
      width: '60px',
      marginLeft: '8px',
    },
  },
  '@keyframes fadeSlideOut': {
    from: {
      opacity: 1,
      width: '60px',
      marginLeft: '8px',
    },
    to: {
      opacity: 0,
      width: '0px',
      marginLeft: 0,
    },
  },
  position: 'absolute',
  top: 0,
  left: '50%',
  transform: 'translate(-50%,0)',
  textAlign: 'center',
  marginTop: '12px',
  border: '1px solid #767676',
  padding: '0 4px',
  borderRadius: '4px',
  display: 'flex',
  alignItems: 'center',
}))
